import React from "react";
import { Coins, Link2, Ticket } from "lucide-react";

import { Switch } from "../../../../components/ui/switch";

import Bloco from "./Bloco";

const OPCOES = [
  { campo: "acumula_cupom", icone: Ticket, rotulo: "Cupom de desconto", sim: "O cupom desconta também no produto em oferta.", nao: "O cupom não desconta em cima de produto em oferta." },
  { campo: "acumula_cashback", icone: Coins, rotulo: "Cashback", sim: "O cliente usa e ganha cashback no produto em oferta.", nao: "Produto em oferta não usa nem gera cashback." },
];

export default function SecaoAcumulo({ config, onMudar }) {
  return (
    <Bloco icone={Link2} titulo="Junta com outros benefícios?" subtitulo="O que acontece quando o produto em oferta encontra cupom ou cashback.">
      <div className="grid sm:grid-cols-2 gap-2.5">
        {OPCOES.map(({ campo, icone: Icone, rotulo, sim, nao }) => {
          const ligado = !!config[campo];
          return (
            <label key={campo} className={`flex items-center gap-3 rounded-xl border-2 p-3 cursor-pointer transition-colors ${ligado ? "border-primary bg-primary/10" : "border-border"}`}>
              <Icone className={`w-6 h-6 shrink-0 ${ligado ? "text-primary" : "text-muted-foreground"}`} />
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold leading-tight">{rotulo}{ligado ? " junta" : " não junta"}</span>
                <span className="block text-[11px] text-muted-foreground leading-snug">{ligado ? sim : nao}</span>
              </span>
              <Switch checked={ligado} onCheckedChange={(v) => onMudar(campo, v)} aria-label={`Acumula com ${rotulo.toLowerCase()}`} />
            </label>
          );
        })}
      </div>
    </Bloco>
  );
}
